import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { Card, Row, Col, ListGroup } from 'react-bootstrap';  // Removed 'Item' since it doesn't exist in React-Bootstrap
import './index.css';

// Import individual profile components
import UserProfile from '../User/UserProfile';
import EmployeeProfile from '../Employee/EmployeeProfile';
import ManagerProfile from '../manager/ManagerProfile';
import Dashboard from '../admin/Dashboard';

const Body = () => {
  // Retrieve data from localStorage
  const email = localStorage.getItem('email');
  const id = localStorage.getItem('userId');
  const role = localStorage.getItem('role');
  //console.log('Role from localStorage:', role);

  const [userData, setUserData] = useState(null);  // State to hold fetched data

  // Fetch user data based on role when the component is mounted
  useEffect(() => {
    const fetchData = async () => {
      let url = '';

      // Set API URLs based on role
      if (role === 'user' && id) {
        url = `https://apiaksharaconnect.aksharafinalytics.in//UD/${id}`;
      } else if (role === 'employee' && id) {
        url = `https://apiaksharaconnect.aksharafinalytics.in/employees/${id}`;  
      } else if (role === 'manager' || role === 'sale manager' && id ) {
        url = `https://apiaksharaconnect.aksharafinalytics.in/managers/${id}`;  
      }
      

      if (url) {
        try {
          const response = await fetch(url);
          if (response.ok) {
            const data = await response.json();
            
            if (role === 'user' && id) {
              if (data.userdetails && data.userdetails.length > 0) {
                setUserData(data.userdetails[0]);
              } else {
                setUserData(data); 
              }
            }else{
              setUserData(data);
            }
            console.log(data);
          } else {
            console.error('Failed to fetch data');
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    };

    fetchData();
  }, [id, role]);  

  if (!userData) {
    return (
      <div className="w-100 course-wrapper">
        <Header />
        <div className="container">
          <h4 className="mx-3 d-block"></h4>

          {/* Profile Section */}
          <section>            
            <Dashboard/>
          </section>
        </div>
      </div>
    );
  }

  // Render different profile components based on the role
  const renderProfileComponent = () => {
    if (role === 'user') {
      return <UserProfile userData={userData} />;
    } else if (role === 'employee') {
      return <EmployeeProfile userData={userData} />;
    } else if (role === 'manager' || role === 'sale manager') {
      return <ManagerProfile userData={userData} />;
    } else if (role === 'admin') {
      return <Dashboard userData={userData} />;
    } 
  };

  return (
    <div className="w-100 course-wrapper">
      <Header />
      <h4 className="mx-3 d-block">Welcome Back</h4>

      {/* Profile Section */}
      <section>
        {renderProfileComponent()}                 
      </section>
    </div>
  );
};

export default Body;
